import React from "react";
import CloudImage from "../CloudImage/CloudImage";

import { Link } from "react-router-dom";

const ServiceSection = (props) => {
  return (
    <section className="wpo-about-section section-padding">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-12 col-12">
            <div className="wpo-about-wrap">
              <div className="wpo-about-img">
                <CloudImage publicId="ebooks.jpg" alt="E-books" />
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-12">
            <div className="wpo-about-text">
              <h2>Troque as telas por aprendizado real.</h2>
              <p className="sub-text">
                A dificuldade de concentração e a frustração com os estudos não
                são culpa do seu filho. São o resultado de um cérebro que não
                está sendo estimulado da maneira correta.
              </p>
              <ul>
                <li>
                  <i className="ti-check"></i>Desperte o prazer de aprender com
                  atividades divertidas que realmente funcionam.
                </li>
                <li>
                  <i className="ti-check"></i>Especialmente eficaz para crianças
                  com TDAH, TEA, Dislexia ou com desafios de aprendizagem.
                </li>
                <li>
                  <i className="ti-check"></i>Acelere o desenvolvimento unindo
                  aprendizado cognitivo e fortalecimento emocional.
                </li>
              </ul>
              <Link onClick={props.link} className="theme-btn">
                QUERO MEU KIT COMPLETO AGORA
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceSection;
